

const apiUrlOne = "https://api.ernivo.tchub.in/api/v1";


export default apiUrlOne;
